/**
 * @fileoverview The pure part of the quick-note shortcuts' rule: a tapped shortcut
 * joins what is already written, cut to a length. No imports, so it can be tested
 * on its own.
 *
 * Where: noteShortcut (notes) and the to-do sheet (OwnTodoSheet).
 * API: none.
 * Settings: none (the caller passes the limit).
 *
 * @module shortcutText
 */

/**
 * A shortcut added to what is already written: taps build one sentence.
 *
 * @param current - What the box says so far.
 * @param label - The shortcut's words.
 * @param max - The length to cut to; undefined before the app has heard the server's limit (uncut, the server's refusal stands).
 * @returns The text with the shortcut on the end.
 */
export function joinShortcut(current: string, label: string, max?: number): string {
  const next = current.trim() ? `${current.trim()} ${label}` : label;
  return max === undefined ? next : next.slice(0, max);
}
